<template>
    <div class="childbirth" :class="{'popup body-popup': true, active: isPopup}" v-if="recordDetail">
        <div class="popup__inner ">
            <div class="popup__certification">
                <div class="popup__tit">
                    <h2>{{transDate(recordDetail.birthDt)}}</h2>
                    <button type="button" class="popup__close"><img src="@/assets/resource/icon/close.svg" alt="" @click="hidePopup"></button>
                </div>
                <div class="popup__body">
                    <div class="body-popup__top">
                        <div class="body-popup__photo">
                            <!-- 사진이 있으면 여기에 들어가면 됩니다 -->
                            <img :src="`/displayFile.do?attachNo=${recordDetail.attachBag.attach[0].attachNo}`"
                                :alt="recordDetail.attachBag.attach[0].altValue || '이미지'"
                                v-if="recordDetail.attachBag.attach" />
                        </div>
                        <div class="table column type03">
                            <table>
                                <colgroup>
                                    <col style="width:120px;">
                                    <col style="width:calc(100% - 120px);">
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th>이름</th>
                                        <td class="left">{{recordDetail.babyName}}</td>
                                    </tr>
                                    <tr>
                                        <th>태명</th>
                                        <td class="left">{{recordDetail.babyBirthName}}</td>
                                    </tr>
                                    <tr>
                                        <th>성별</th>
                                        <td class="left">{{recordDetail.gender == 'M' ? '남자' : '여자'}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="table column type03">
                        <table>
                            <colgroup>
                                <col style="width:120px;">
                                <col style="width:calc((100% - 240px) / 2);">
                                <col style="width:120px;">
                                <col style="width:calc((100% - 240px) / 2);">
                            </colgroup>
                            <tbody>
                                <tr v-if="recordDetail.height || recordDetail.weight">
                                    <template v-if="recordDetail.height">
                                        <th>신장</th>
                                        <td class="left">{{ recordDetail.height }} cm</td>
                                    </template>
                                    <template v-if="recordDetail.weight">
                                        <th>체중</th>
                                        <td class="left">{{ recordDetail.weight }} kg</td>
                                    </template>
                                </tr>
                                <tr v-if="recordDetail.headSize || recordDetail.childbirthProgress">
                                    <template v-if="recordDetail.headSize">
                                        <th>머리둘레</th>
                                        <td class="left">{{ recordDetail.headSize }} cm</td>
                                    </template>
                                    <template v-if="recordDetail.childbirthProgress">
                                        <th>분만방법</th>
                                        <td class="left">자연분만</td>
                                    </template>
                                </tr>
                                <tr v-if="recordDetail.memo">
                                    <th>기타메모</th>
                                <td class="left" colspan="3">{{recordDetail.memo}}</td>
                                </tr>
                                <tr v-if="recordDetail.refDoctorList">
                                    <th>담당의</th>
                                    <td class="left" colspan="3">
                                        <div class="professor-photo" v-for="doctor in recordDetail.refDoctorList" :key="doctor.drSid">
                                            <div class="img">
                                                <img :src="`/displayFile.do?attachNo=${doctor.attachBag.profile[0].attachNo}`"
                                                    :alt="doctor.attachBag.profile[0].altValue || '이미지'"
                                                    v-if="doctor.attachBag.profile" />
                                            </div>
                                            <div class="cont">
                                                <h4 class="title03">{{doctor.name}} 교수</h4>
                                                <a :href="`/kr/doctorInfo?drSid=${doctor.drSid}&deptCd=${doctor.deptCd}`" target="_blank">의료진 정보</a>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="botton-wrap">
                        <a href="javascript:;" class="sub-button c-main" @click="updateRecord">수정</a>
                        <a href="javascript:;" class="main-button c-main" @click="delItems">삭제</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <ul class="tab-menu">
        <li class="tab-menu__item">
            <router-link to="/kr/mypage/babyNote/babyDiary">산모일기</router-link>
        </li>
        <li class="tab-menu__item">
            <router-link to="/kr/mypage/babyNote/checkupRecord">검진기록</router-link>
        </li>
        <li class="tab-menu__item active">
            <router-link to="/kr/mypage/babyNote/birthRecord">출산기록</router-link>
        </li>
    </ul>
    <div class="full-width baby">
        <img src="/resource/img/mom-full-width.png" alt="" class="full-width--bg">
        <h3 class="title01">
            <span class="font-main">새로운 생명의 탄생</span>을 진심으로 축하드립니다. <br>
            아이와 가족 모두에게  <span class="font-main">평안과 기쁨</span>이 가득하기를 기원합니다.
        </h3>
        <div class="botton-wrap">
            <router-link to="/kr/mypage/babyNote/birthRecordRegister" class="main-button c-main">출산 기록 하기</router-link>
        </div>
    </div>
    <ul class="childbirth-list">
        <li class="childbirth-item" v-for="record in recordList" :key="record.mbSn">
            <a href="javascript:;" @click="showPopup(record)">
                <div class="img">
                    <img :src="`/displayFile.do?attachNo=${record.attachBag.attach[0].attachNo}`" :alt="record.attachBag.attach[0].altValue || '이미지'" v-if="record.attachBag.attach" />
                </div>
                <h4 class="title02">{{record.babyName}}({{record.babyBirthName}})</h4>
                <p class="title03">{{$commonUtils.dateToStr(new Date(record.birthDt), '-')}}</p>
            </a>
        </li>
    </ul>
  </template>
  
  <script>
  
  export default {
    components: {
    },
    data() {
        return {
            recordList: [],
            recordDetail: '',
            isPopup: false,
        };
    },
    methods: {
        getList() {
            this.axios.get(this.api.mypage.recordList)
                .then(res => {
                    this.recordList = res.data.result.list
            })
        },
        showPopup(record) {
            this.isPopup = true
            this.recordDetail = record
        },
        hidePopup(){
            this.isPopup = false
            this.recordDetail = ''
        },
        transDate(date){
            var d = new Date(date);

            var year = d.getFullYear();
            var month = (d.getMonth() + 1).toString().padStart(2, '0');
            var day = d.getDate().toString().padStart(2, '0');
            var hour = d.getHours();
            var minute = d.getMinutes().toString().padStart(2, '0');

            var ampm = hour < 12 ? '오전' : '오후';
            hour = hour % 12;
            hour = hour ? hour : 12;

            return `${year}년 ${month}월 ${day}일 ${ampm} ${hour}시 ${minute}분`;
        },
        updateRecord(){
            this.$router.push({path: "/kr/mypage/babyNote/birthRecordRegister", query: {mbSn: this.recordDetail.mbSn}})
        },
        delItems() {
            if (confirm('기록을 삭제하시겠습니까?')) {
                this.axios({
                    method: "post",
                    url: this.api.mypage.recordDel,
                    params: { 'mbSn': this.recordDetail.mbSn }
                }).then(response => {
                    this.isPopup = false;
                    this.getList();
                });
            }
        },
    },
    mounted() {
        this.getList()
    },
  };
  </script>
  <style scoped></style>